<template lang="pug">
  div.qcw-chat-wrapper
    div.qcw-main
      svg-icon

      image-modal(:comment="imageModalContent"
        :closeBtnHandler="closeImageModal"
        v-if="imageModalIsActive")

      comment-reply-preview(v-if="repliedComment && core.UI.config.showRepliedForm"
        :core="core"
        :comment="repliedComment"
        :closeReplyHandler="closeReply")

      upload-info(v-if="uploadedFiles.length > 0"
        :files="uploadedFiles")

      chat-header(v-if="core.selected && core.UI.config.showHeader"
        :core="core"
        @toggle-window="() => toggleWindowStatus()"
        @header-click="() => headerClickedHandler()"
        @back-to-channel="() => onBackToChannelIframe()")

      //- div(v-if="!core.selected" class="empty-state")
      //-   //- img(v-if="core.UI.emptyStateUrl" :src="core.UI.emptyStateUrl")
      //-   icon(v-if="core.UI.emptyStateUrl" name="ic-empty-state" style="width: 24px; height: 24px;")
      //-   div Loading ...

      attachment-form(
        :uploadHandler="uploadFile"
        :displaying="showAttachmentForm"
        v-if="showAttachmentForm"
        :attachmentData="attachmentData"
        :setAttachmentData="setAttachmentData"
        :closeFormHandler="toggleAttachmentForm"
      )

      file-drag-drop(
        :core="core"
        :dragging="dragging"
        @onDragging="onDragging")

      comment-list-email(
        v-if="isEmailMode"
        :core="core"
        :replyHandler="setReply"
        :onupdate="scrollToBottom")

      comment-list(
        v-else
        :core="core"
        :on-click-image="openImageModal"
        :repliedComment="repliedComment"
        :replyHandler="setReply"
        :onupdate="scrollToBottom"
        @onDragging="onDragging")

      assistant-result(:core="core"
        :menu="assistant.menu"
        :chatHistory="assistant.chatHistory"
        :assistantResult="assistant.result"
        :agentInput="assistant.agentInput" 
        :channelId="assistant.channel_id"
        @assistant-changes="assistantChanges"
        @assistant-apply="assistantApply"
        @assistant-result="assistantResultChange"
        :langs="assistant.langs")

      comment-form(:core="core"
        v-if="core.UI.config.showCommentForm && core.selected"
        :repliedComment="repliedComment"
        :showAttachmentForm="showAttachmentForm"
        :toggleAttachmentForm="toggleAttachmentForm"
        :setAttachmentData="setAttachmentData"
        :closeReplyHandler="closeReply"
        :isEmailMode="isEmailMode"
        :isAssistant="assistant.show"
        :assistantResult="assistant.result"
        :currentMenu="assistant.menu"
        :assistantApply="assistant.apply"
        @assistant-apply="assistantApply"
        @assistant-enabled="assistantShowStatus"
        @assistant-changes="assistantChanges"
        @assistant-language="setLanguages")

    //- Start of message info
    message-info(v-if="core.UI.isMessageInfoActive" :core="core")
</template>

<script>
import SvgIcon from "./SVGIcon";
import Icon from "./Icon";
import CommentList from "./CommentList";
import CommentForm from "./CommentForm";
import CommentReplyPreview from "./CommentReplyPreview";
import CommentListEmail from "./CommentListEmail";
import { scrollIntoLastElement } from "../lib/utils";
import ImageModal from "./ImageModal";
import UploadInfo from "./UploadInfo";
import ChatHeader from "./ChatHeader";
import FileDragDrop from "./FileDragDrop";
import { uploadFile } from "../lib/fileUploader";
import AttachmentForm from "./AttachmentForm";
import MessageInfo from "./MessageInfo";
import AssistantResult from "./ai-assistant/result";

export default {
  name: "ChatWindow",
  props: ["core", "toggleWindowStatus", "onBackToChannelIframe"],
  components: {
    CommentList,
    SvgIcon,
    Icon,
    CommentForm,
    CommentReplyPreview,
    ImageModal,
    UploadInfo,
    ChatHeader,
    FileDragDrop,
    AttachmentForm,
    MessageInfo,
    CommentListEmail,
    AssistantResult
  },
  data() {
    return {
      repliedComment: null,
      imageModalContent: null,
      imageModalIsActive: false,
      dragging: false,
      showAttachmentForm: false,
      attachmentData: {
        thumbnail: null,
        file: null
      },
      assistant: {
        show: false,
        menu: null,
        chatHistory: null,
        result: "",
        apply: false,
        agentInput: "",
        channel_id: null,
        langs: []
      }
    };
  },
  computed: {
    showIsTypingStatus() {
      const self = this;
      if (this.core.isTypingStatus) {
        window.setTimeout(() => {
          self.core.isTypingStatus = "";
        }, 3000);
        return true;
      }
      return false;
    },
    uploadedFiles() {
      if (!this.core.selected) return [];
      return this.core.uploadedFiles.filter(
        f => f.roomId === this.core.selected.id
      );
    },
    myReactiveColor() {
      if (this.core.isTypingStatus) {
        return this.core.UI.colors.statusTypingColor;
      } else if (
        this.core.chatmateStatus === "Online" &&
        this.core.selected.room_type !== "group"
      ) {
        return this.core.UI.colors.statusOnlineColor;
      }
      return this.core.UI.colors.statusOfflineColor;
    },
    participants() {
      const limit = 3;
      const overflowCount = this.core.selected.participants.length - limit;
      const participants = this.core.selected.participants
        .slice(0, limit)
        .map(item => item.username.split(" ")[0]);
      if (this.core.selected.participants.length <= limit)
        return participants.join(", ");
      return participants.concat(`and ${overflowCount} others.`).join(", ");
    },
    isEmailMode() {
      if (!this.core.selected || !("options" in this.core.selected))
        return false;
      const options = this.core.selected.options
        ? JSON.parse(this.core.selected.options)
        : {};
      const isEmailModeInit = window.qiscusUIEmailMode || false;
      if (Object.keys(options).length > 0) {
        const scalar = options.scalar ? JSON.parse(options.scalar) : {};
        if (Object.keys(scalar).length > 0) {
          return (
            this.core.mode === "wide" &&
            scalar.channel === "email" &&
            isEmailModeInit
          );
        }
        return false;
      }
      return false;
    }
  },
  watch: {
    "core.UI.config.showRepliedForm": {
      handler(newVal) {
        if (newVal !== null && !newVal) {
          this.repliedComment = null;
        }
      }
    }
  },
  methods: {
    assistantChanges(value) {
      this.assistant.agentInput = value.input;
      this.assistant.chatHistory = value.history;
      this.assistant.menu = value.menu;
      this.assistant.channel_id = value.channel_id;
    },
    assistantShowStatus(value) {
      this.assistant.show = value;
    },
    assistantApply(value) {
      this.assistant.apply = value;
    },
    assistantResultChange(value) {
      this.assistant.result = value;
      this.assistant.agentInput = value;
    },
    setAttachmentData(data) {
      this.attachmentData.file = data.file;
      this.attachmentData.thumbnail = data.thumbnail;
      this.showAttachmentForm = true;
    },
    toggleAttachmentForm() {
      this.showAttachmentForm = !this.showAttachmentForm;
      document.querySelectorAll(
        ".qcw-comment-form input[type=file]"
      )[1].value = null;
    },
    headerClickedHandler() {
      this.core.options.headerClickedCallback();
    },
    openImageModal(comment) {
      this.imageModalContent = comment;
      this.imageModalIsActive = true;
    },
    closeImageModal() {
      this.imageModalIsActive = false;
      this.imageModalContent = null;
    },
    setReply(comment) {
      if (!this.core.selected || !("options" in this.core.selected))
        return false;
      const options = this.core.selected.options
        ? JSON.parse(this.core.selected.options)
        : {};

      // check room wa or not
      if (
        Object.keys(options).length > 0 &&
        options.channel &&
        options.channel == "wa"
      ) {
        // check comment has wa_wamid or not, if not call load_comments sdk
        if (
          comment.unique_temp_id &&
          comment.unique_temp_id.toLowerCase().includes("wa_wamid")
        ) {
          this.onSetReply(comment);
        } else {
          this.core
            .loadComments(this.core.selected.id, {
              last_comment_id: comment.id,
              after: true
            })
            .then(res => {
              const detail = res.find(item => item.id == comment.id);
              if (detail) comment.unique_temp_id = detail.unique_temp_id;

              const uniqArr = this.core.selected.comments.filter(
                (obj, index) => {
                  return (
                    index ===
                    this.core.selected.comments.findIndex(o => obj.id === o.id)
                  );
                }
              );
              this.core.selected.comments = uniqArr;

              this.onSetReply(comment);
            })
            .catch(() => {
              this.onSetReply(comment);
            });
        }
      } else {
        this.onSetReply(comment);
      }
    },
    onSetReply(comment) {
      this.closeReply();
      this.repliedComment = comment;
      this.core.UI.config.showRepliedForm = true;
      // focus the textarea of commentform
      const element = document.querySelector(".qcw-comment-form textarea");
      if (element) element.focus();
    },
    closeReply() {
      this.repliedComment = null;
      this.core.UI.config.showRepliedForm = false;
    },
    scrollToBottom() {
      scrollIntoLastElement(this.core);
    },
    onDragging(status) {
      this.dragging = status;
    },
    uploadFile(file, caption) {
      uploadFile(file, caption, this.core, this.$toasted);
      this.showAttachmentForm = false;
    },
    setLanguages(value) {
      this.assistant.langs = value;
    }
  }
};
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600')
@import '../assets/stylus/_variables.styl'

.qcw-chat-wrapper
  width 360px
  height 0
  display flex
  // box-shadow 0 7px 16px rgba(46,46,46,.15)
  border-radius 32px
  overflow hidden
  position absolute
  transition all .15s ease-in-out
  bottom 64px
  background-color $white
  .qcw-container.qcw-container--open &
    height 480px

    @media screen and (max-width: 600px)
      right 0
      bottom 0
      width 100vw
      height 100vh
      z-index 1
      border-radius 0

.qcw-main
  width 100%
  display flex
  flex-direction column
  position relative

.qcw-window-toggle-btn
  visibility hidden
  display none
  @media screen and (max-width: 400px)
    cursor pointer
    flex 0 0 32px
    align-items center
    justify-content flex-end
    display flex
    visibility visible
    svg
      margin-top 0

.qcw-header
  flex 0 0 73px
  background $white
  display flex
  align-items center
  padding 13px 16px
  border-bottom 0.5px solid $lightGrey
  gap: 12px;

  @media screen and (max-width: 600px)
    padding 32px
    border-bottom unset
  .qcw-header-avatar
    flex 0 0 48px
    display flex
    @media screen and (max-width: 600px)
      flex 0 0 32px
  .qcw-header-avatar img
    width 48px
    height 48px
    border-radius 50%

    @media screen and (max-width: 600px)
      width 32px
      height 32px
      margin-top 0
  .qcw-header-info
    flex 1
    color $dark
    .qcw-user-display-name
      font-size 15px
      font-weight 600
      @media screen and (max-width: 600px)
        font-size 14px
        font-weight 600
        line-height 16px
    .qcw-user-status
      font-size 13px
      white-space: nowrap;
      overflow: hidden;

      @media screen and (max-width: 600px)
        font-size 12px
        font-weight 400
        line-height 16px

.qcw-comments
  flex 1
  overflow hidden
  overflow-y auto
  position relative

.qcw-comment-form
  flex 0 0 64px
  background #FFF
  border-top 0.5px solid $lightGrey

.qcw-avatar--hide
  visibility hidden

.reply-wrapper
  position relative
  padding 16px 8px
  background-color $darkWhite
  margin-bottom 8px
  border-radius 2px
  cursor pointer
  &.reply-wrapper--me
    background-color $darkerWhite;
  .reply-sender
    font-size 12px
    font-weight 400
    color $grey
  .qcw-comment__content
    font-size 14px
    color $dark
    font-weight 400
    line-height 20px
    overflow hidden
    overflow-y auto
    max-height 150px
    width auto
    white-space pre-line
    word-break break-word
  .image-loader--text
    color: #666
  &:before
    all unset
  // content ""
  // position: absolute
  // left 0px
  // top 0px
  // width 8px
  // height calc(100% - 0px)
  // background $brown
  // border-radius 2px 0 0 2px

  &.reply-wrapper--preview
    margin-bottom 0
    order 1
    width: calc(100% - 64px);
    background-color $white
    padding 16px 8px
    margin-inline 32px
    animation fadeInUp 0.3s ease-out
    // box-shadow 0 -8px 16px rgba(199,199,199,0.2)
    border-top 1px solid $lightGrey;
    &:before
      all unset

  &.reply-wrapper--redownload
    margin-top: 8px
    &:before
      background: #D9D9D9
    .qcw-comment__content
      max-height: unset

.reply-close-btn
  position absolute
  right 32px
  top 16px
  font-size 10px
  cursor pointer
  svg.qc-icon
    height 12px
    width 12px

.empty-state
    display flex
    flex-direction column
    align-items center
    justify-content center
    width 100%
    height 100%
    padding 30px
    background #FFF
    text-align center
    font-size 14px
</style>



// WEBPACK FOOTER //
// src/components/ChatWindow.vue